import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const GridIcon: FC<IconProps> = ({
  color = theme.palette.text.default,
  size = IconSize.medium,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.5 3.20002C9.5 2.77997 9.5 2.56995 9.58175 2.40951C9.65368 2.26839 9.76835 2.15365 9.90951 2.08174C10.0699 2 10.2799 2 10.7 2H12.8001C13.2201 2 13.4301 2 13.5906 2.08174C13.7317 2.15365 13.8464 2.26839 13.9183 2.40951C14.0001 2.56995 14.0001 2.77997 14.0001 3.20002V5.30005C14.0001 5.72009 14.0001 5.93012 13.9183 6.09055C13.8464 6.23168 13.7317 6.34641 13.5906 6.41833C13.4301 6.50007 13.2201 6.50007 12.8001 6.50007H10.7C10.2799 6.50007 10.0699 6.50007 9.90951 6.41833C9.76835 6.34641 9.65368 6.23168 9.58175 6.09055C9.5 5.93012 9.5 5.72009 9.5 5.30005V3.20002Z"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 3.20002C2 2.77997 2 2.56995 2.08174 2.40951C2.15365 2.26839 2.26839 2.15365 2.40951 2.08174C2.56995 2 2.77997 2 3.20002 2H5.30005C5.72009 2 5.93012 2 6.09055 2.08174C6.23168 2.15365 6.34641 2.26839 6.41833 2.40951C6.50007 2.56995 6.50007 2.77997 6.50007 3.20002V5.30005C6.50007 5.72009 6.50007 5.93012 6.41833 6.09055C6.34641 6.23168 6.23168 6.34641 6.09055 6.41833C5.93012 6.50007 5.72009 6.50007 5.30005 6.50007H3.20002C2.77997 6.50007 2.56995 6.50007 2.40951 6.41833C2.26839 6.34641 2.15365 6.23168 2.08174 6.09055C2 5.93012 2 5.72009 2 5.30005V3.20002Z"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 10.7C2 10.2799 2 10.0699 2.08174 9.90951C2.15365 9.76835 2.26839 9.65368 2.40951 9.58175C2.56995 9.5 2.77997 9.5 3.20002 9.5H5.30005C5.72009 9.5 5.93012 9.5 6.09055 9.58175C6.23168 9.65368 6.34641 9.76835 6.41833 9.90951C6.50007 10.0699 6.50007 10.2799 6.50007 10.7V12.8001C6.50007 13.2201 6.50007 13.4301 6.41833 13.5906C6.34641 13.7317 6.23168 13.8464 6.09055 13.9183C5.93012 14.0001 5.72009 14.0001 5.30005 14.0001H3.20002C2.77997 14.0001 2.56995 14.0001 2.40951 13.9183C2.26839 13.8464 2.15365 13.7317 2.08174 13.5906C2 13.4301 2 13.2201 2 12.8001V10.7Z"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 10.7C9.5 10.2799 9.5 10.0699 9.58175 9.90951C9.65368 9.76835 9.76835 9.65368 9.90951 9.58175C10.0699 9.5 10.2799 9.5 10.7 9.5H12.8001C13.2201 9.5 13.4301 9.5 13.5906 9.58175C13.7317 9.65368 13.8464 9.76835 13.9183 9.90951C14.0001 10.0699 14.0001 10.2799 14.0001 10.7V12.8001C14.0001 13.2201 14.0001 13.4301 13.9183 13.5906C13.8464 13.7317 13.7317 13.8464 13.5906 13.9183C13.4301 14.0001 13.2201 14.0001 12.8001 14.0001H10.7C10.2799 14.0001 10.0699 14.0001 9.90951 13.9183C9.76835 13.8464 9.65368 13.7317 9.58175 13.5906C9.5 13.4301 9.5 13.2201 9.5 12.8001V10.7Z"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  </>
)
